/* eslint-disable-prettier/prettier */
import { decimalFormatter } from "./decimalFormatter";
export const fscFormatter = (ppr, cpm) => {
   if (ppr) { return `${decimalFormatter(ppr)}%` }
   else if (cpm) { return `$${decimalFormatter(cpm)}/mi` }
   else { return "" }
};
